import { defineRecipe } from '@chakra-ui/react';

export const input = defineRecipe({
  className: 'chakra-input',
  variants: {
    size: {
      xs: {
        borderRadius: 'md',
        fontSize: 'xs',
        '--input-height': 'sizes.6',
      },
      sm: {
        borderRadius: 'md',
        fontSize: 'sm',
        paddingX: 3,
        '--input-height': 'sizes.8',
      },
      md: {
        fontSize: 'sm',
        borderRadius: 'md',
        paddingX: 4,
        _dark: {
          borderRadius: 'sm',
        },
      },
    },

    variant: {
      outline: {
        bg: 'transparent',
        borderWidth: '1px',
        borderColor: 'gray.400',
        borderRadius: 'md',
        focusVisibleRing: 'inside',
        _hover: {
          borderColor: 'blue.300',
        },
        _focusVisible: {
          borderColor: 'blue.500',
          boxShadow: `0 0 0 1px var(--chakra-colors-blue-focus-ring)`, // blue.50
        },
        _disabled: {
          bg: 'gray.100',
          borderColor: 'on-navy.200',
          opacity: 0.4,
          _hover: {
            // Disable hover state for disabled
            borderColor: 'on-navy.200',
          },
        },
        _placeholder: {
          // Defaults to 0.6 - setting to 1 so we can explicitly set the colour we want
          opacity: 1,
          color: 'gray.600',
        },
        _dark: {
          bg: 'white',
          _disabled: {
            borderColor: 'gray.400',
            bg: 'gray.50',
            _hover: {
              // Disable hover state for disabled
              borderColor: 'gray.400',
            },
          },
          _hover: {
            borderColor: 'link',
          },
          _focusVisible: {
            borderColor: 'link',
          },
        },
      },
    },
  },

  defaultVariants: {
    size: 'md',
    variant: 'outline',
  },
});
